import Vue from 'vue';
import App from './App.vue';
import '../../css/common.scss';
import '../../js/swiper/swiper-bundle.min.css';

import utils from '../../js/utils.js';
Vue.prototype.$utils = utils;

//import axios from '../../js/request.js';
//Vue.prototype.$axios = axios;

Vue.config.productionTip = true;
new Vue({
  render: h => h(App),
}).$mount('#app')
